import {
  Alert,
  Box,
  Section,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSkeleton,
  Typography,
} from '@cmg/design-system';
import React from 'react';

import { useRolodex_FirmDetail_FirmLinkageSummaryQuery } from './graphql/__generated__';

type Props = {
  firmId: string;
};

export const FirmLinkageSummaryPanel: React.FC<Props> = ({ firmId }) => {
  const { data, loading, error } = useRolodex_FirmDetail_FirmLinkageSummaryQuery({
    variables: { firmId },
  });

  const linkageSummary = data?.firms?.items?.[0]?.linkageSummary;
  const linkFrequency = linkageSummary?.linkFrequency ?? 0;
  const bankRelationships = linkageSummary?.bankRelationships ?? [];

  if (loading) {
    return (
      <Section title="Linkage Summary">
        <TableSkeleton numOfColumns={4} />
      </Section>
    );
  }

  if (error) {
    return (
      <Section title="Linkage Summary">
        <Alert severity="error">{error.message}</Alert>
      </Section>
    );
  }

  return (
    <Section title="Linkage Summary" px={4}>
      <Box>
        <Stack direction="row" alignItems="center" gap={2}>
          <Typography variant="body2" color="text.secondary">
            LINK FREQUENCY
          </Typography>
          <Typography variant="body2">{linkFrequency}</Typography>
        </Stack>
        <TableContainer>
          <Table aria-label="Linkage Summary">
            <TableHead>
              <TableRow>
                <TableCell>Sell Side Client</TableCell>
                <TableCell>Sell Side CMG Entity Key</TableCell>
                <TableCell>CRM Firm Name</TableCell>
                <TableCell>CRM FirmKey</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {bankRelationships.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Typography variant="body2" color="text.secondary">
                      No records available
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
              {bankRelationships.map(relationship => (
                <TableRow key={relationship.bankCmgEntityKey}>
                  <TableCell>
                    <Typography variant="body2">{relationship.bankName}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">{relationship.bankCmgEntityKey}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {relationship.linkedInvestorFirms.map(f => f.name).join(', ')}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">
                      {relationship.linkedInvestorFirms.map(f => f.firmKey).join(', ')}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Section>
  );
};
